export const MARKETO = 'marketo';
export const SALESFORCE = 'salesforce';
export const MARKETO_CUSTOM = 'marketo_custom';
export const MW_APP_SERVICE = 'mw_app_service';
